
import React from 'react';
import { Linkedin, Mail, Phone } from 'lucide-react';
import { Link } from 'react-router-dom';

const Footer: React.FC = () => {
  return (
    <footer className="bg-gray-900 text-white py-16 px-6 md:px-10">
      <div className="container mx-auto">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12">
          <div>
            <div className="flex items-center mb-4">
              <img src="/lovable-uploads/2a4ca809-1e4b-4f11-9936-d9e370f05626.png" alt="Sparkwave AI Logo" className="h-10 mr-2" />
              <h3 className="text-xl font-glacial">SPARKWAVE AI</h3>
            </div>
            <p className="text-gray-300 mb-6">
              Empowering businesses with cutting-edge AI solutions that drive growth and efficiency.
            </p>
            <div className="flex space-x-4">
              <a href="https://www.linkedin.com/in/scott-johnson-1b76535/" target="_blank" rel="noopener noreferrer" className="text-gray-400 hover:text-primary transition-colors">
                <Linkedin size={20} />
              </a>
            </div>
          </div>
          
          <div>
            <h4 className="text-lg font-semibold mb-4">Solutions</h4>
            <ul className="space-y-3">
              <li><Link to="/services#ai-consulting" className="text-gray-300 hover:text-primary transition-colors">AI Consulting</Link></li>
              <li><Link to="/services#ai-agents" className="text-gray-300 hover:text-primary transition-colors">AI Agents & Automation</Link></li>
              <li><Link to="/services#ai-voice" className="text-gray-300 hover:text-primary transition-colors">AI Voice & Speech</Link></li>
              <li><Link to="/services#custom-ai" className="text-gray-300 hover:text-primary transition-colors">Custom AI Development</Link></li>
            </ul>
          </div>
          
          <div>
            <h4 className="text-lg font-semibold mb-4">Company</h4>
            <ul className="space-y-3">
              <li><Link to="/about" className="text-gray-300 hover:text-primary transition-colors">About Us</Link></li>
              <li><Link to="/portfolio" className="text-gray-300 hover:text-primary transition-colors">Our Work</Link></li>
              <li><Link to="/ai-apps" className="text-gray-300 hover:text-primary transition-colors">AI Apps</Link></li>
              <li><a href="#" className="text-gray-300 hover:text-primary transition-colors">Blog</a></li>
            </ul>
          </div>
          
          <div>
            <h4 className="text-lg font-semibold mb-4">Contact</h4>
            <ul className="space-y-3">
              <li className="flex items-center">
                <Mail size={18} className="mr-2 text-primary" />
                <a href="mailto:info@sparkwave-ai.com" className="text-gray-300 hover:text-primary transition-colors">
                  info@sparkwave-ai.com
                </a>
              </li>
              <li className="flex items-center">
                <Phone size={18} className="mr-2 text-primary" />
                <a href="tel:+19195324050" className="text-gray-300 hover:text-primary transition-colors">
                  (919) 532-4050
                </a>
              </li>
            </ul>
          </div>
        </div>
        
        <div className="border-t border-gray-800 mt-12 pt-8 flex flex-col md:flex-row justify-between items-center">
          <p className="text-gray-400 text-sm mb-4 md:mb-0">
            © {new Date().getFullYear()} Sparkwave AI. All rights reserved.
          </p>
          <div className="flex space-x-6">
            <a href="#" className="text-gray-400 hover:text-primary transition-colors text-sm">
              Privacy Policy
            </a>
            <a href="#" className="text-gray-400 hover:text-primary transition-colors text-sm">
              Terms of Service
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
